import React, {PureComponent} from 'react'
import {connect} from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import {withRouter} from 'react-router-dom';
import SuperAdminHeader from './../../components/Header/SuperAdmin';
import Footer from './../../components/Footer';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import Alert from './../../components/Errors/Alert'
import AlertSuccess from './../../components/Success/Alert'

class SuperAdminSettings extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            resetPasswordModalOpen: false,
            user: {},
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            resetPasswordSuccess: false
        };
        autobind(this)
    }

    componentDidMount() {
        const {user} = this.props;
        this.setState({
            user: user
        });
    }

    componentWillReceiveProps(props, context) {
        const {user} = props;
        this.setState({
            user: user
        });
    }

    toggleResetPasswordModal() {
        this.setState({
            resetPasswordModalOpen: !this.state.resetPasswordModalOpen
        })
    }

    updateCurrentPassword(e) {
        this.setState({
            currentPassword: e.target.value
        })
    }

    updateNewPassword(e) {
        this.setState({
            newPassword: e.target.value
        })
    }

    updateConfirmNewPassword(e) {
        this.setState({
            confirmNewPassword: e.target.value
        })
    }

    resetPassword() {
        this.props.resetPassword({
            oldPassword: this.state.currentPassword,
            newPassword: this.state.newPassword,
            newPasswordConfirmation: this.state.confirmNewPassword
        }, () => {
            this.setState({
                resetPasswordSuccess: true
            })
        });
    }


    render() {
        const {resetPasswordError} = this.props;
        if (this.state.resetPasswordSuccess) {
            setTimeout(() => this.setState({
                resetPasswordModalOpen: false,
                resetPasswordSuccess: false,
                currentPassword: '',
                newPassword: '',
                confirmNewPassword: ''
            }), 500)
        }

        return (
            <div className="superadmin">
                <SuperAdminHeader/>
                <div className="container mt-5">
                    <div className="panel panel-default">
                        <div className="panel-body panel-body--md">
                            <h5 className="mb-5">Account Settings</h5>
                            <div className="form-group mb-1 row">
                                <label htmlFor="email" className="col-3 col-form-label">Email</label>
                                <div className="col-9">
                                    <p className="col-form-label text-highlighted">{this.state.user.email}</p>
                                </div>
                            </div>
                            <button className="btn btn-space btn-sm-lateral-space btn-secondary btn-rounded btn-lg mt-4"
                                    onClick={this.toggleResetPasswordModal}>Change Password
                            </button>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.resetPasswordModalOpen} toggle={this.toggleResetPasswordModal} className="modal-md">
                    <ModalHeader>
                        <span onClick={this.toggleResetPasswordModal} className="s7-close modal-close">&nbsp;</span>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        <div className="row d-flex justify-content-center">
                            <div className="col-8">
                                {this.state.resetPasswordSuccess ? (
                                    <AlertSuccess message="Your password has been reset." path={null}/>) : null}{resetPasswordError ?
                                <Alert message={resetPasswordError}/> : null}
                                <label className="mb-3">Current password:</label>
                                <input type="password" placeholder="Current password" className="form-control form-control-xs mb-4"
                                       value={this.state.currentPassword} onChange={this.updateCurrentPassword}/>
                                <label className="mb-3">New password:</label>
                                <input type="password" placeholder="New password" className="form-control form-control-xs mb-4"
                                       value={this.state.newPassword} onChange={this.updateNewPassword}/>
                                <input type="password" placeholder="Confirm new password" className="form-control form-control-xs mb-4"
                                       value={this.state.confirmNewPassword} onChange={this.updateConfirmNewPassword}/>
                                <button className="btn btn-space btn-primary" onClick={this.resetPassword}>Confirm change password</button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Footer/>
            </div>
        )
    }
}

export default connect(
    (state, ownProps) => {
        const {auth: {user, resetPasswordError}} = state;
        return {user, resetPasswordError}
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps)
    }
)(withRouter(SuperAdminSettings))


// WEBPACK FOOTER //
// ./src/containers/SuperAdmin/SuperAdminSettings.js